// extracted by mini-css-extract-plugin
module.exports = {"container":"filters-bar_container__AK94U","tab":"filters-bar_tab__pDrFz","active":"filters-bar_active__FZGzC","link":"filters-bar_link__S9nrv"};